export type IGenerateWebservicePostJson = ($form: JQuery<HTMLFormElement>) => IDCA.IGenericObj;

export function generateWebservicePostJson($form: JQuery<HTMLFormElement>): IDCA.IGenericObj {
  const { formIdentifier, ownerIdentifier } = window.DexeroCoreApp.userOptions;
  const obj: IDCA.IGenericObj = {};
  const body: IDCA.IGenericObj = {};

  body.data = window.DexeroCoreApp.getFormValuesObj($form);
  body.forceCardCreation = true;
  body.waitForEvent = true;

  obj.body = body;
  obj.formIdentifier = formIdentifier;
  obj.ownerIdentifier = ownerIdentifier;
  return obj;
}
